// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DefaultUserPhoto_wrapper__kpX1H"};